import { createStore } from '@servicetitan/financing-utils-shared';
import { useState } from 'react';

function useSecondLookServiceDegraded(initialState: boolean = false) {
    const [isSecondLookServiceDegraded, setIsSecondLookServiceDegraded] = useState(initialState);
    return { isSecondLookServiceDegraded, setIsSecondLookServiceDegraded };
}

export const SecondLookServiceDegradedStore = createStore(useSecondLookServiceDegraded);
export type SecondLookServiceDegradedStore = ReturnType<typeof useSecondLookServiceDegraded>;
